import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { CustomInput } from "src/component";
import { renderAlert, renderToastMsg } from "src/utils/functions";
import { adminPasswordUpdate, updateProfilePassword } from "src/services/api";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";

const UpdatePassword = ({
    editData,
    refetch,
    setModalOpen,
}) => {

    const { user } = useProtectedRoutesContext();
    const isAdmin = user?.role === "admin";

    const initialValues = {
        old_password: "",
        new_password: "",
    };
    const adminInitialValues = {
        new_password: "",
    };

    const passwordSchema = yup.object().shape({
        old_password: yup
            .string()
            .required("Old password is required"),
        new_password: yup
            .string()
            .required("New password is required")
            .min(8, "Password must be 8 characters long")
            .matches(/[0-9]/, "Password requires a number")
            .matches(/[a-z]/, "Password requires a lowercase letter")
            .matches(/[A-Z]/, "Password requires an uppercase letter")
            .matches(/[^\w]/, "Password requires a symbol"),
    });
    const adminPasswordSchema = yup.object().shape({
        new_password: yup
            .string()
            .required("New password is required")
            .min(8, "Password must be 8 characters long")
            .matches(/[0-9]/, "Password requires a number")
            .matches(/[a-z]/, "Password requires a lowercase letter")
            .matches(/[A-Z]/, "Password requires an uppercase letter")
            .matches(/[^\w]/, "Password requires a symbol"),
    });

    const { mutate, isLoading } = useMutation(isAdmin ? adminPasswordUpdate : updateProfilePassword, {
        onSuccess: (res) => {
            if (res?.status === "success") {

                renderAlert({
                    title: "Success",
                    msg: res?.msg,
                    type: "success",
                }).then((result) => {

                    if (result) {
                        setModalOpen(false);
                    } else {
                        setModalOpen(false);
                    }
                });
                refetch();
            } else {
                renderToastMsg(res?.msg);
            }

        },
    });


    return (
        <>
            <Formik
                initialValues={isAdmin ? adminInitialValues : initialValues}
                validationSchema={isAdmin ? adminPasswordSchema : passwordSchema}
                onSubmit={(values) => {

                    if (isAdmin) {
                        let data = {
                            id: editData?.id,
                            new_password: values?.new_password
                        }
                        mutate(data);
                    } else {

                        let data = {
                            id: editData?.id,
                            old_password: values?.old_password,
                            new_password: values?.new_password
                        }
                        mutate(data);
                    }

                }}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="px-[3rem] py-[2rem]">
                            {!isAdmin && (

                                <CustomInput
                                    title="Old Password"
                                    name="old_password"
                                    passwordToggle
                                    onChange={handleChange}
                                    value={values.old_password}
                                    onBlur={handleBlur}
                                    formType="fill"
                                    isRequired={true}
                                />
                            )}
                            <CustomInput
                                title="New Password"
                                name="new_password"
                                passwordToggle
                                onChange={handleChange}
                                value={values.new_password}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                            />


                        </div>

                        <div className="border-t border-t-gray">
                            <div className="flex justify-end px-[3rem] py-[2rem]">
                                <button
                                    disabled={isLoading}
                                    type="submit"
                                    className="btn-loader flex justify-center bg-lightPrimary items-center rounded-[5px]  text-defaultPrimary py-[2rem] px-[4rem] h-[3.5rem]"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default UpdatePassword;
